import type { LeagueFixtureResult, LeagueTeam, TeamId } from './types'
import { COMPETITION_CLUBS, COMPETITION_TEAMS, generateRegularSeasonFixture } from './competition'

export const USER_TEAM_ID = 'kingsport'
export const SEASON_SEED = 91731
export const TEAMS: Record<TeamId, LeagueTeam> = COMPETITION_TEAMS
/** Compatibility export for read-only screens; new seasons call the generator with their season number. */
export const SEASON_FIXTURES = generateRegularSeasonFixture(COMPETITION_CLUBS, 1)
/** v56 starts fresh at Round 1. */
export const PREPLAYED_RESULTS: LeagueFixtureResult[] = []

export interface OpponentProfile {
  strengths: string[]
  weaknesses: string[]
  style: string
  assessment: string
  staffChoices: ['A' | 'B' | 'C', 'A' | 'B' | 'C', 'A' | 'B' | 'C', 'A' | 'B' | 'C', 'A' | 'B' | 'C']
  conditional: { label: string; condition: string; action: string }
}

const choices = (_rating: number): OpponentProfile['staffChoices'] => ['A', 'A', 'A', 'A', 'B']

export const OPPONENT_PROFILES: Record<TeamId, OpponentProfile> = Object.fromEntries(COMPETITION_CLUBS.map(team => [team.id, {
  strengths: [...(team.strengths ?? [])],
  weaknesses: [...(team.weaknesses ?? [])],
  style: team.style ?? 'Balanced football',
  assessment: `Disrupt ${team.nickname}'s preferred ${team.style?.toLowerCase() ?? 'shape'} and make them defend a different game.`,
  staffChoices: choices(team.simulationRating),
  conditional: {
    label: `Change shape after repeated ${team.nickname} entries`,
    condition: `${team.name} generates three consecutive forward entries.`,
    action: 'Protect the corridor, stabilise possession and release through width.',
  },
}]))

export interface OpponentCoachProfile {
  name: string
  tacticalAbility: number
  preparation: number
  adaptability: number
  riskAppetite: number
  preferredApproach: 'conservative' | 'balanced' | 'aggressive' | 'analytical'
}

export const OPPONENT_COACHES: Record<TeamId, OpponentCoachProfile> = Object.fromEntries(COMPETITION_CLUBS.map(team => [team.id, {
  name: team.coach!.name,
  tacticalAbility: team.coach!.tacticalAbility,
  preparation: team.coach!.preparation,
  adaptability: team.coach!.adaptability,
  riskAppetite: team.coach!.riskAppetite,
  preferredApproach: team.coach!.preferredApproach,
}]))
